export const languageOptions = [
  { value: "en", label: "English" },
  { value: "es", label: "Spanish" },
  { value: "fr", label: "French" },
  { value: "de", label: "German" },
  { value: "it", label: "Italian" },
  { value: "pt", label: "Portuguese" },
  { value: "ru", label: "Russian" },
  { value: "ja", label: "Japanese" },
  { value: "ko", label: "Korean" },
  { value: "zh", label: "Chinese" },
  { value: "ar", label: "Arabic" },
  { value: "hi", label: "Hindi" },
  { value: "bn", label: "Bengali" },
  { value: "ur", label: "Urdu" },
  { value: "tr", label: "Turkish" },
  { value: "nl", label: "Dutch" },
  { value: "sv", label: "Swedish" },
  { value: "da", label: "Danish" },
  { value: "no", label: "Norwegian" },
  { value: "fi", label: "Finnish" },
  { value: "pl", label: "Polish" },
  { value: "cs", label: "Czech" },
  { value: "sk", label: "Slovak" },
  { value: "hu", label: "Hungarian" },
  { value: "ro", label: "Romanian" },
  { value: "bg", label: "Bulgarian" },
  { value: "hr", label: "Croatian" },
  { value: "sr", label: "Serbian" },
  { value: "sl", label: "Slovenian" },
  { value: "et", label: "Estonian" },
  { value: "lv", label: "Latvian" },
  { value: "lt", label: "Lithuanian" },
  { value: "el", label: "Greek" },
  { value: "he", label: "Hebrew" },
  { value: "th", label: "Thai" },
  { value: "vi", label: "Vietnamese" },
  { value: "id", label: "Indonesian" },
  { value: "ms", label: "Malay" },
  { value: "tl", label: "Filipino" },
  { value: "jv", label: "Javanese" },
  { value: "su", label: "Sundanese" },
  { value: "min", label: "Minangkabau" },
  { value: "ace", label: "Acehnese" },
  { value: "ban", label: "Balinese" },
  { value: "bug", label: "Buginese" },
  { value: "mad", label: "Madurese" },
  { value: "bjn", label: "Banjarese" },
  { value: "gor", label: "Gorontalo" },
  { value: "mak", label: "Makassarese" },
  { value: "rej", label: "Rejang" },
  { value: "sas", label: "Sasak" },
  { value: "sun", label: "Sundanese" },
  { value: "tet", label: "Tetum" },
  { value: "ceb", label: "Cebuano" },
  { value: "hil", label: "Hiligaynon" },
  { value: "war", label: "Waray" },
  { value: "pam", label: "Kapampangan" },
  { value: "bik", label: "Bikol" },
  { value: "pag", label: "Pangasinan" },
  { value: "ilo", label: "Ilocano" },
  { value: "cbk", label: "Chavacano" },
  { value: "tsg", label: "Tausug" },
  { value: "kab", label: "Kabyle" },
  { value: "shi", label: "Tachelhit" },
  { value: "rif", label: "Tarifit" },
  { value: "ber", label: "Berber" },
  { value: "am", label: "Amharic" },
  { value: "ti", label: "Tigrinya" },
  { value: "om", label: "Oromo" },
  { value: "so", label: "Somali" },
  { value: "sw", label: "Swahili" },
  { value: "zu", label: "Zulu" },
  { value: "xh", label: "Xhosa" },
  { value: "af", label: "Afrikaans" },
  { value: "st", label: "Southern Sotho" },
  { value: "tn", label: "Tswana" },
  { value: "sn", label: "Shona" },
  { value: "rw", label: "Kinyarwanda" },
  { value: "rn", label: "Kirundi" },
  { value: "mg", label: "Malagasy" },
  { value: "yo", label: "Yoruba" },
  { value: "ig", label: "Igbo" },
  { value: "ha", label: "Hausa" },
  { value: "ff", label: "Fula" },
  { value: "wo", label: "Wolof" },
  { value: "bm", label: "Bambara" },
  { value: "dy", label: "Dyula" },
  { value: "sg", label: "Sango" },
  { value: "ln", label: "Lingala" },
  { value: "lg", label: "Ganda" },
  { value: "ach", label: "Acoli" },
  { value: "lwo", label: "Luo" },
  { value: "kik", label: "Kikuyu" },
  { value: "kam", label: "Kamba" },
  { value: "luo", label: "Luo" },
  { value: "mas", label: "Maasai" },
  { value: "mer", label: "Meru" },
  { value: "kln", label: "Kalenjin" },
  { value: "teo", label: "Teso" },
  { value: "guz", label: "Gusii" },
  { value: "dav", label: "Taita" },
  { value: "ebu", label: "Embu" },
  { value: "thk", label: "Tharaka" },
  { value: "mij", label: "Mijikenda" },
  { value: "dgo", label: "Dogri" },
  { value: "doi", label: "Dogri" },
  { value: "sat", label: "Santali" },
  { value: "mni", label: "Manipuri" },
  { value: "bho", label: "Bhojpuri" },
  { value: "awa", label: "Awadhi" },
  { value: "mag", label: "Magahi" },
  { value: "mai", label: "Maithili" },
  { value: "raj", label: "Rajasthani" },
  { value: "brx", label: "Bodo" },
  { value: "mwr", label: "Marwari" },
  { value: "hne", label: "Chhattisgarhi" },
  { value: "kru", label: "Kurukh" },
  { value: "sck", label: "Sadri" },
  { value: "kha", label: "Khasi" },
  { value: "lus", label: "Mizo" },
  { value: "grt", label: "Garo" },
  { value: "kac", label: "Kachin" },
  { value: "shn", label: "Shan" }
];
